import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

export type BadgeTone = 'neutral' | 'primary' | 'success' | 'warning' | 'info' | 'danger'

export const BADGE_TONES: Record<BadgeTone, string> = {
    neutral: 'border-border bg-muted text-muted-foreground',
    primary: 'border-primary/20 bg-primary/10 text-primary',
    success: 'border-success/25 bg-success/10 text-success',
    warning: 'border-warning/25 bg-warning/10 text-warning',
    info: 'border-info/25 bg-info/10 text-info',
    danger: 'border-destructive/25 bg-destructive/10 text-destructive'
}

type BadgeProps = {
    tone?: BadgeTone
    dot?: boolean
    className?: string
    title?: string
    children: ReactNode
}

export const Badge: FC<BadgeProps> = ({ tone = 'neutral', dot = false, className, title, children }): ReactNode => {
    return (
        <span
            title={title}
            className={cn(
                'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap',
                BADGE_TONES[tone],
                className
            )}
        >
            {dot && <span className='size-1.5 shrink-0 rounded-full bg-current' aria-hidden='true' />}
            {children}
        </span>
    )
}
